import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { PlankSymbol, Lockup } from "./Logo";

const COLS = [
  ["Shop", [["/product/pustak-rack", "Pustak Rack"], ["/shop", "Modular storage"], ["/#how-it-builds", "How it builds"], ["/wishlist", "Wishlist"]]],
  ["H&W", [["/story", "Our story"], ["/#faq", "Delivery & returns"], ["/#faq", "Building help"]]],
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-walnut text-linen">
    <PlankSymbol bar="currentColor" className="pointer-events-none absolute -bottom-28 -right-20 h-[460px] w-[460px] text-linen/[0.04]" />
    <div className="container-hw relative grid gap-12 py-16 md:grid-cols-12">
      <div className="md:col-span-5">
        <Link to="/" data-testid="footer-logo-link" aria-label="H&W Furniture home"><Lockup reverse className="h-12" /></Link>
        <p className="mt-6 max-w-sm font-display text-2xl text-jute">Build it together.</p>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-linen/75">
          H&amp;W stands for Husband &amp; Wife. We are a Hyderabad business making do-it-yourself modular furniture that you build together and grow one shelf at a time.
        </p>
      </div>
      {COLS.map(([title, links]) => (
        <div key={title} className="md:col-span-2">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-brass">{title}</p>
          <ul className="mt-5 space-y-3 text-sm">
            {links.map(([to, label]) => (
              <li key={label}><Link to={to} className="text-linen/80 transition-colors hover:text-linen">{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
      <div className="md:col-span-3">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-brass">Talk to us</p>
        <a href="mailto:care@hwfurniture.in" data-testid="footer-email" className="mt-5 flex items-center gap-2 text-sm text-linen/80 hover:text-linen"><Mail className="h-4 w-4" />care@hwfurniture.in</a>
        <p className="mt-3 text-sm text-linen/60">Mon to Sat, 10am to 7pm</p>
        <p className="mt-3 text-sm text-linen/60">Kondapur, Hyderabad, Telangana</p>
        <p className="mt-6 text-sm text-linen/60">Free delivery across Hyderabad. Pay by cash or UPI when your box arrives.</p>
      </div>
    </div>
    <div className="container-hw relative flex flex-col justify-between gap-2 border-t border-linen/10 py-6 text-xs text-linen/50 sm:flex-row">
      <span>© {new Date().getFullYear()} H&amp;W Furniture. Made in Hyderabad.</span>
      <span>Delivering only in Hyderabad and Secunderabad. Prices in INR; GST shown at checkout.</span>
    </div>
  </footer>
);
